import withMobileDialog from '@material-ui/core/withMobileDialog';

export default withMobileDialog;